// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import React from 'react'
import { useTranslation } from 'react-i18next'

export const SessionLost = () => {
  const { t } = useTranslation(['apps'])
  return (
    <div data-testid="oidc-session-lost">
      <div data-testid="oidc-session-lost__container">
        <h1 data-testid="oidc-session-lost__title">{t('session_expired')}</h1>
        <p data-testid="oidc-session-lost__content">
          {t('session_expired_text')}
        </p>
      </div>
    </div>
  )
}

export default SessionLost
